import classNames from "classnames";
import Swal from "sweetalert2";
import usePDFDownload from "../../../hooks/usePDFDownload";
import useSharedData from "../../../hooks/useSharedData";
import LoadingButton from "../../Loading/LoadingButton";
import styles from "./PrintLink.module.css";

const PrintLink = ({
  ids = [],
  className = "",
  children,
  byNumberParcel = false,
  onError = undefined,
}) => {
  const { isAuthed } = useSharedData();

  const { isPending, mutate } = usePDFDownload({
    url: "/totalpost/v1/mainFactor",
    body: {
      ids,
      byNumberParcel: byNumberParcel ?? false,
    },
    onError,
  });

  const classes = classNames("btn btn-outline-primary text-center", styles.btn);

  const isWrong =
    !isAuthed ||
    !ids ||
    ids.length === 0 ||
    ids[0] === null ||
    ids[0] === undefined;

  const onClick = () => {
    if (isWrong) {
      Swal.fire({
        icon: "error",
        text: "انتخاب حداقل یک سفارش الزامی است",
        confirmButtonColor: "red",
        confirmButtonText: "باشه",
      });
      return;
    }

    mutate();
  };

  if (isPending) {
    return (
      <LoadingButton
        className={className || classes}
        center
        title="در حال دریافت"
      />
    );
  }

  return (
    <button
      className={className || (isWrong ? "d-none" : classes)}
      onClick={onClick}
      title="پرینت فاکتور"
    >
      {children}
    </button>
  );
};

export default PrintLink;
